/* globals jQuery, define */

define([], function(){
  function get() {
    return new Promise(function(resolve, reject) {
      var headers = {};
      var token = getCookie('datix.jwtToken');
      if (token) {
        headers.Authorization = 'Bearer ' + token;
      }
      jQuery.ajax({url: '/api/public/users/me', headers: headers})
        .done(resolve)
        .fail(reject);
    });
  }

  function getDefaultLocale(locale) {
    if (!locale) {
      locale = globals.language ? globals.language.replace('-', '_') : 'en_GB';
    }
    return locale;
  }
  function getLocale() {
    return new Promise(function(resolve, reject) {
      get().then(function(resp) {
        var locale = resp && resp.data && resp.data.settings &&
          resp.data.settings.language && resp.data.settings.language.code;

        locale = getDefaultLocale(locale);

        resolve(locale);
      })
        .catch(reject);
    });
  }

  function getISOLocale() {
    return new Promise(function(resolve, reject) {
      get().then(function(resp) {
        var locale = resp && resp.data && resp.data.settings &&
          resp.data.settings.language && resp.data.settings.language.princeCode;

        locale = getDefaultLocale(locale);

        resolve(locale);
      })
        .catch(reject);
    });
  }

  function getCookie(name) {
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + name + '=');
    if (parts.length == 2) return parts
      .pop()
      .split(';')
      .shift();
  }

  return {
    get          : get,
    getLocale    : getLocale,
    getISOLocale : getISOLocale
  };
});
